import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 11v.01","key":"svg-0"}],["path",{"d":"M8 11v.01","key":"svg-1"}],["path",{"d":"M16 11v.01","key":"svg-2"}],["path",{"d":"M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z","key":"svg-3"}]]

const IconMessageDots = createReactComponent('outline', 'message-dots', 'MessageDots', __iconNode);

export default IconMessageDots;